import React from 'react';

import ProductItem from '../ProductItem';

import * as S from './styles';

interface IGridProps {
  items: any[];
  componenteVitrineId?: number;
}

const Grid: React.FC<IGridProps> = ({ items, componenteVitrineId }) => {
  return (
    <S.Container className="grid">
      {items?.map(item => (
        <ProductItem
          key={`grid-${item.id}`}
          item={item}
          componenteVitrineId={componenteVitrineId}
        />
      ))}
    </S.Container>
  );
};

export default Grid;
